import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FloatLabelType, MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MobileNumberFormatPipe } from '@app/shared/pipes/mobile-number-format.pipe';

@Component({
  selector: 'app-mobile-number-input',
  imports: [MatFormField, MatLabel, CommonModule, MatError, ReactiveFormsModule, MatInputModule],
  templateUrl: './mobile-number-input.component.html',
  styleUrl: './mobile-number-input.component.scss',
  providers: [MobileNumberFormatPipe], // Provide the pipe
})
export class MobileNumberInputComponent {
  @Input() label!: string;
  @Input() control!: FormControl;
  @Input() placeholder!: string;
  @Input() floatLabel: FloatLabelType = 'auto';

  @Output() getValue = new EventEmitter<any>();
  phoneNumber: string = '';

  constructor(private phoneNumberFormatPipe: MobileNumberFormatPipe) {}

  ngOnInit(): void {
    // Initialize control with validators for exactly 10 digits
    this.control.addValidators([Validators.minLength(10), Validators.maxLength(10)]);

    this.updatePhoneNumber(this.control.value);
  }

  inputChanged(event: any) {
    const inputValue = event;
    this.updatePhoneNumber(inputValue);

    if (inputValue === '') {
      this.control.setValue(null);
    }

    this.getValue.emit(inputValue);
  }

  private updatePhoneNumber(value: any) {
    if (value && typeof value === 'string') {
      this.phoneNumber = this.phoneNumberFormatPipe.transform(value);
    } else {
      this.phoneNumber = '';
    }
  }

  validateKeyPress(event: KeyboardEvent) {
    // Getting the input character from the key pressed
    const inputChar = event.key;
    const currentValue = (event.target as HTMLInputElement).value;

    // Allows only digits (0-9) and control keys (backspace, arrow keys)
    if (!/^[0-9]$/.test(inputChar) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key)) {
      event.preventDefault();
    }

    // Ensuring the first digit is between 6 and 9
    if (currentValue.length === 0 && !/^[6-9]$/.test(inputChar)) {
      event.preventDefault();
    }
  }
}
